package ui.home.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.icons.EsMediumIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import ui.home.NavSidebarItem

@Composable
fun NavSidebarIconButton(
    onClick: () -> Unit,
    item: NavSidebarItem,
    badgeCount: Int,
    isSelected: Boolean,
    modifier: Modifier,
) {
    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        BadgedBox(
            badge = {
                if (badgeCount > 0)
                    Badge(
                        modifier = Modifier.padding(end = 2.spacing),
                        containerColor = Color.Red,
                        contentColor = Color.White,
                    ) {
                        Text(
                            text = badgeCount.toString(),
                        )
                    }
            },
        ) {
            Box(
                modifier = modifier
                    .clip(RoundedCornerShape(2.spacing))
                    .background(
                        with(MaterialTheme.esColorScheme) {
                            if (isSelected) bgSecondary
                            else Color.Transparent
                        },
                    )
                    .clickable {
                        onClick()
                    }
                    .padding(1.spacing),
            ) {
                EsMediumIcon(
                    res = item.iconRes,
                    tint = with(MaterialTheme.esColorScheme) {
                        if (isSelected) iconPrimary
                        else iconSecondary
                    },
                )
            }
        }

        Text(
            text = item.title,
            style = MaterialTheme.esTypography.p2Medium14.copy(
                fontSize = 12.sp,
                color = with(MaterialTheme.esColorScheme) {
                    if (isSelected) primary
                    else textSecondary
                },
            ),
            modifier = Modifier
                .offset(y = (-2).dp),
        )
    }
}